<template>
  <v-row class="pa-0 ma-0 po-r" id="banner" v-if="banner">
    <v-col
      cols="12"
      v-if="banner.componentType === 'text'"
      :style="{
        backgroundImage: `url(${getImgURL(banner.data.imgLink)})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundBlendMode: 'multiply',
        backgroundColor: '#00000010'
      }"
      class="banner d-flex justify-center align-center ma-0 w-100 h-100 po-r">
      <v-row class="pa-0 ma-0 d-flex justify-center align-center z-1">
        <v-col cols="12" md="10" xl="8" class="pa-0 ma-0">
            <v-col cols="12" class="py-0 font-B">
              <h2 class="w-fit banner_title banner-font-h3">
                {{ t(banner.data.title) }}
              </h2>
              <div class="w-100 banner_engtitle banner-font-h5">
                {{ t(banner.data.engtitle) }}
              </div>
            </v-col>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  props: ["banner"],
  data: () => ({
    title: '',
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    axios
      .get("/tools/json/menu.json")
      .then((response) => {
        this.title = response.data[1].name;
      });
  },
  methods: {
    getImgURL(URL) {
      if (URL.includes('https')) {
        return URL;
      } else {
        return `/tools/img_2/${URL}`;
      }
    },
  },
};
</script>

<style lang="scss">
.banner {
  background-image: url("../../public/tools/img_2/banner/01.jpg");
  height: 25vh;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner_title {
  margin-bottom: 0;
  color: #fff;
}

.banner_engtitle {
  margin-top: 0;
  white-space: normal;
  color: #fff;
}

.banner-font-h1 {
  font-size: 3.5em;
}

.banner-font-h2 {
  font-size: 2.0em;
}

.banner-font-h3 {
  font-size: 1.8em;
}

.banner-font-h4 {
  font-size: 1.5em;
}

.banner-font-h5 {
  font-size: 1.2em;
}

.banner-font-h6 {
  font-size: 1.0em;
}

.banner-font-small{
  font-size: 0.5em;
}
</style>